import 'babel-polyfill';
import $ from 'jquery';
import round10 from 'round10';
import '../../core/utils/jquery.countdown';
import '../../core/utils/jquery.ajax.abort';

import '../../core/styles/fonts.styl';
import '../../core/styles/application.styl';
import './styles/preload.styl';

import _ from 'lodash';
import Backbone from 'backbone';

import '../../core/extends';

import { LodashMixines, Secret, fbInit } from '../../core/utils';

import App from './App';

round10.polyfill();
fbInit();
_.mixin(LodashMixines);

$(document).ready(() => {
	const app = new App();

	new Secret(JSON.parse(process.env.IS_PRE_SEASON));

	if (!window.is_app_view) {
		(function(w,d,s){
			var f=d.getElementsByTagName(s)[0],
				j=d.createElement(s);
			j.onload = function () {
				window.stripe = Stripe(process.env.STRIPE_PK);
			}
			j.src= 'https://js.stripe.com/v3/';
			f.parentNode.insertBefore(j,f);
		})(window,document,'script');
	}

	app.start();

	Backbone.history.start({
		pushState: true,
		root: '/'
	});

	$(document).on('click', 'a[href^="/"]:not([href^="//"], [target^="_blank"])',  e => {
		e.preventDefault();

		const href = $(e.currentTarget).attr('href');

		Backbone.history.navigate(href, { trigger: true });
	});
});